<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg"  xmlns:xlink="http://www.w3.org/1999/xlink" :width="size" :height="size" viewBox="0 0 16 16">

        <circle  cx="8" cy="8" r="8"  stroke-width="0.4" fill="orange" >
        </circle>

        <g transform="translate(2 1.5) scale(0.8)" fill="white" class="TQ_Animation_fadeInRight">
            <path fill="white" d="M2 13h2l5-5-5-5h-2l5 5z"></path>
            <path fill="white" d="M7 13h2l5-5-5-5h-2l5 5z"></path>
        </g>


    </svg>
</template>

<script>
    export default {
        name: "si_skip",
        props:{
            size:{
                type: String,
                default: '48px'
            }
        }
    }
</script>

<style scoped lang="scss">


</style>